import type { PushUnsubscribeInput } from '@rp/contracts'
import { z } from 'zod'
import type { ApiClient } from '../../api/client'
import { currentPushSubscription, pushSupported } from './pushBrowser'
import { PUSH_SUBSCRIPTIONS_PATH } from './pushQueries'

export const PUSH_CLEANUP_BUDGET_MS = 2_000

const PushAck = z.unknown()

const withinBudget = (cleanup: Promise<void>): Promise<void> =>
  new Promise((resolve) => {
    const timer = setTimeout(resolve, PUSH_CLEANUP_BUDGET_MS)
    void cleanup.catch(() => undefined).finally(() => {
      clearTimeout(timer)
      resolve()
    })
  })

const deviceSubscription = async (): Promise<PushSubscription | null> => {
  if (!pushSupported()) return null
  return currentPushSubscription().catch(() => null)
}

const forget = async (api: ApiClient): Promise<void> => {
  const subscription = await deviceSubscription()
  if (subscription === null) return
  const body: PushUnsubscribeInput = { endpoint: subscription.endpoint }
  await api.request(PushAck, { method: 'DELETE', path: PUSH_SUBSCRIPTIONS_PATH, body }).catch(() => undefined)
  await subscription.unsubscribe().catch(() => false)
}

const unsubscribe = async (): Promise<void> => {
  const subscription = await deviceSubscription()
  await subscription?.unsubscribe().catch(() => false)
}

export const forgetPushSubscription = (api: ApiClient): Promise<void> => withinBudget(forget(api))

export const unsubscribeDevicePush = (): Promise<void> => withinBudget(unsubscribe())
